import { render, staticRenderFns } from "./PublicUserSettings.vue?vue&type=template&id=34856da4&"
import script from "./PublicUserSettings.vue?vue&type=script&lang=js&"
export * from "./PublicUserSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports